import React, {useState, useEffect, useMemo} from 'react';
import { useNavigate, Link} from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';
import { set } from 'draft-js/lib/DefaultDraftBlockRenderMap';

function Documentos() {
    
    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
        //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
        //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
        }, []);
    
    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };

    const toggleLogoff = () => {
        localStorage.clear();
        localStorage.setItem('loggedIn', false);
        localStorage.removeItem('user');
        sessionStorage.clear();
        
        navigate('/');
        window.location.reload();
    }

    const [documentos, setDocumentos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);

    useEffect(() => {
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        setIsLoadingMOD(true);
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/routes.php?metodo=obtemDocumentos',
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                if(response.data && response.data.length > 0){
                    setDocumentos(response.data);
                }
                else {
                    setDocumentos([]);
                }
                    
                setIsLoadingMOD(false)
            })
            .catch(error => {
                let ret = error.message;
                setIsLoadingMOD(false);
                if (ret.includes("401")) {
                    console.log("token inválido!")
                }
                else if (ret.includes("403")) {
                    //window.location.reload();
                }
            })
    }, []);

    function handleSelectStatusChange(event) {
        sessionStorage.selectStatusRegistroDocumentos = event.target.value
        setSelectStatus(sessionStorage.selectStatusRegistroDocumentos)
    }

    function handleNovoCadastro() {
        //setModalOpen(false);
    }

    function handleExibirPDF(documento) {
        //console.log(documento);
        //return;
        //navigate(`/ViewPDF`, { state: { registro: documento } });
        window.open(window.location.origin + '/api/' + documento.docCaminho, '_blank', 'noopener,noreferrer');
    }

    function handleEnviarDocumento(documento) {
        navigate(`/EnviarDocumento/${documento.IdDocumento}`);
    }

    function handleEditDocumento(documento) {
        //setModalInfo(documento);
        //setModalOpen(true);
        navigate(`/Documento`, { state: { documentoInfo: documento } });
        //window.location.reload();
    }

    //salvar log de navegação
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Navegação",
        logModulo: "Página de Documentos",
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data[0].mensagem);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
        });
    }, []);

    const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = useState(config);
  
      const sortedItems = useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
          sortableItems.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
              return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
              return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
          });
        }
        return sortableItems;
      }, [items, sortConfig]);
  
      const requestSort = key => {
        let direction = 'ascending';
        if (sortConfig && 
          sortConfig.key === key && 
          sortConfig.direction === 'ascending'
        ) {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
      };
  
      return { items: sortedItems, requestSort, sortConfig };
    };
    const { items, requestSort, sortConfig } = useSortableData(documentos);

    const getClassNamesFor = name => {
    if (!sortConfig) {
    return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined
    }

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
    const handleResize = () => {
    setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
    window.removeEventListener('resize', handleResize);
    };
    }, []);
    
    //console.log(documentos);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Menu de navegação */}
                    <div>
                        <MenuAssociados />
                    </div>
                    {/* Titulos da página */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >DOCUMENTOS</label>
                        <label className='labelSubTitulo'>Lista de Documentos</label>
                    </div>
                    {/* Pesquisa filtro e Novo */}
                    <div className="containerBarraPesquisa">
                        
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        // <Link to="/Documento">
                            <button className="buttonModalPadrao" onClick={() => navigate(`/Documento`)}>
                                NOVO DOCUMENTO
                            </button>
                        // </Link> 
                        ) : ('')}

                        <input className="inputBarraPesquisa"
                        placeholder="PESQUISAR"
                        type="text"
                        id="inputPesquisa"
                        name="inputPesquisa"
                        onChange={event => {
                            setSearchTerm(event.target.value)
                        }}
                        />

                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <select className="selectStatusPesquisa"
                        name="selectStatusRegistroDocumentos"
                        selected={sessionStorage.selectStatusRegistroDocumentos !== undefined ? sessionStorage.selectStatusRegistroDocumentos : '99'}
                        onChange={event => {
                            handleSelectStatusChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusRegistroDocumentos === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusRegistroDocumentos === '1'} >ATIVOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusRegistroDocumentos === '0'} >INATIVOS</option>
                        </select>
                        ) : ('')}
                    </div>

                    {/* Tabela de documentos */}
                    <div className="tabelaPadrao">
                        {windowWidth < 769 ? (
                            <div>
                                {isLoadingMOD ? (
                                    <p><CircularProgress /></p>
                                ) : (
                                    items && items.length > 0 ? (
                                        items
                                        .filter(val => {
                                            if (searchTerm === '') {
                                                if(sessionStorage.selectStatusRegistroDocumentos !== undefined && sessionStorage.selectStatusRegistroDocumentos === '99')
                                                {
                                                    return val
                                                }
                                                else if (sessionStorage.selectStatusRegistroDocumentos !== undefined && sessionStorage.selectStatusRegistroDocumentos !== '99')
                                                {
                                                    if(parseInt(sessionStorage.selectStatusRegistroDocumentos) === parseInt(val.docStatus))
                                                    {
                                                        return val
                                                    }
                                                }
                                                else{
                                                    return val
                                                }
                                            } else if (
                                                val.docDescricao
                                                .toLowerCase()
                                                .includes(searchTerm.toLowerCase()) 
                                                ||
                                                val.docObservacoes
                                                .toLowerCase()
                                                .includes(searchTerm.toLowerCase()) 
                                                ||
                                                val.docTipo
                                                .toLowerCase()
                                                .includes(searchTerm.toLowerCase())
                                            ) {
                                                if(sessionStorage.selectStatusRegistroDocumentos !== undefined && sessionStorage.selectStatusRegistroDocumentos === '99')
                                                {
                                                    return val
                                                }
                                                else if (sessionStorage.selectStatusRegistroDocumentos !== undefined && sessionStorage.selectStatusRegistroDocumentos !== '99')
                                                {
                                                    if(parseInt(sessionStorage.selectStatusRegistroDocumentos) === parseInt(val.docStatus))
                                                    {
                                                        return val
                                                    }
                                                }
                                                else{
                                                    return val
                                                }
                                            }
                                        })
                                        .map(documento => (
                                            <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '15px' }}>
                                                <div key={documento.IdDocumento}>
                                                    <div onClick={() => handleEditDocumento(documento)}>
                                                        <p style={{ color: '#000' }}><b>CÓD:</b> {documento.IdDocumento}</p>
                                                        <p style={{ color: '#000', marginTop: '10px' }}><b>DESCRIÇÃO:</b> {documento.docDescricao}</p>
                                                        <p style={{ color: '#000', marginTop: '10px' }}><b>TIPO:</b> {documento.docTipo}</p>
                                                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                                        <p style={{ verticalAlign: 'middle', color: parseInt(documento.docStatus) === 1 ? 'green' : 'red', marginTop: '10px' }}><b>STATUS:</b> {parseInt(documento.docStatus) === 1 ? <ThumbUpAlt style={{ marginBottom: '-5px' }} /> : <ThumbDownOffAlt style={{ marginBottom: '-5px' }} />}</p>
                                                        ) : ('')}
                                                    </div>
                                                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                                    <p style={{ color: '#000', marginTop: '10px' }}>{documento.docCaminho ? 
                                                        <button className="buttonGridPadrao" 
                                                            onClick={() => handleEnviarDocumento(documento)}>
                                                            Enviar
                                                        </button> : 'Documento não disponível'}
                                                    </p>
                                                    ) : ('')}
                                                    <p style={{ color: '#000', marginTop: '20px' }}> {documento.docCaminho ? 
                                                        <button className="buttonGridPadrao" 
                                                            onClick={() => handleExibirPDF(documento)}>
                                                            Visualizar
                                                        </button> : ''}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p style={{ color: '#000', textAlign: 'center', marginTop: '20px' }}>Nenhum documento encontrado.</p>
                                    )
                                )}
                            </div>
                        ) : (
                        <table>
                            <thead>
                                <tr style={{ cursor: 'pointer' }}>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('docCodigo')} className={getClassNamesFor('docCodigo')}>
                                    CÓD
                                    </th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('docDescricao')} className={getClassNamesFor('docDescricao')}>
                                    DESCRIÇÃO
                                    </th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('docTipo')} className={getClassNamesFor('docTipo')}>
                                    TIPO
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('docDocumento')} className={getClassNamesFor('docDocumento')}>
                                    DOCUMENTO
                                    </th>
                                    <th></th>
                                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('docStatus')} className={getClassNamesFor('docStatus')}>
                                    STATUS
                                    </th>
                                    ) : ('')}
                                </tr>
                            </thead>
                            <tbody>
                            {
                                isLoadingMOD ? <tr><td colSpan="5" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                                items && items.length > 0 && 
                                items
                                .filter(val => {
                                    if (searchTerm === '') {
                                        //return val
                                        if(sessionStorage.selectStatusRegistroDocumentos !== undefined 
                                            && sessionStorage.selectStatusRegistroDocumentos === '99')
                                        {
                                            return val
                                        }
                                        else if (sessionStorage.selectStatusRegistroDocumentos !== undefined 
                                            && sessionStorage.selectStatusRegistroDocumentos !== '99')
                                        {
                                            if(parseInt(sessionStorage.selectStatusRegistroDocumentos) === parseInt(val.docStatus))
                                            {
                                            return val
                                            }
                                        }
                                        else{
                                            return val
                                        }
                                    } else if (
                                        val.docDescricao
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) 
                                        ||
                                        val.docObservacoes
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) 
                                        ||
                                        val.docTipo
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) 
                                    ) {
                                        if(sessionStorage.selectStatusRegistroDocumentos !== undefined 
                                            && sessionStorage.selectStatusRegistroDocumentos === '99')
                                        {
                                            return val
                                        }
                                        else if (sessionStorage.selectStatusRegistroDocumentos !== undefined 
                                            && sessionStorage.selectStatusRegistroDocumentos !== '99')
                                        {
                                            if(parseInt(sessionStorage.selectStatusRegistroDocumentos) === parseInt(val.docStatus))
                                            {
                                                return val
                                            }
                                        }
                                        else{
                                            return val
                                        }
                                    }
                                })
                                    .map(documento => {
                                        return (
                                        <tr style={{ cursor: 'pointer' }} key={documento.IdDocumento}>
                                            <td className='tdAlignCenter' onClick={() => handleEditDocumento(documento)}>
                                                {documento.IdDocumento}
                                            </td>

                                            <td style={{textTransform: 'uppercase'}} onClick={() => handleEditDocumento(documento)}>
                                                {documento.docDescricao}
                                            </td>

                                            <td style={{textTransform: 'uppercase'}} onClick={() => handleEditDocumento(documento)}>
                                                {documento.docTipo}
                                            </td>

                                            <td style={{textTransform: 'uppercase'}} className='tdAlignCenter'
                                                onClick={documento.docCaminho 
                                                ? () => handleExibirPDF(documento) : null} >
                                                {documento.docCaminho ? 
                                                <button className="buttonGridPadrao" >
                                                    Documento
                                                </button> : ''}
                                            </td>

                                            <td>
                                                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                                <button className="buttonGridPadrao" onClick={() => handleEnviarDocumento(documento)}>
                                                    Enviar
                                                </button>
                                                ) : ('')}
                                            </td>

                                            {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                            <td width={40} className='tdAlignCenter' 
                                                onClick={() => handleEditDocumento(documento)}>
                                                <label className="btnMGUPermissoes" style={{ color: parseInt(documento.docStatus) === 1 ? 'green' : 'red' }} >
                                                    {parseInt(documento.docStatus) === 1 ? <ThumbUpAlt /> : <ThumbDownOffAlt />}
                                                    {/* <span className="checkmark"></span> */}
                                                </label>
                                            </td>
                                            ) : ('')}
                                        </tr>
                                    )})
                                }
                            </tbody>
                        </table>
                        )}
                    </div>
                </div>
            </main>
        </div>
    )
}

export default Documentos;